<template>
    <div>
      <warApportionmentReports/>
    </div>
</template>

<script>
import warApportionmentReports from '../../components/apportionment/remitWarrants.vue';

export default {
  name: 'apportionment',
  data: () => ({

  }),
  components: {
    warApportionmentReports,
  },
};
</script>
